import React from "react";

const FormCheckbox = ({
  field,
  value,
  handleChange,
  disabled = false,
  error,
}) => {
  /**
   * Determine if checkbox is checked
   * - Single checkbox → boolean
   * - Multiple values (array) → check if field.value exists in array
   */
  const isChecked = Array.isArray(value)
    ? value.includes(field.value)
    : Boolean(value);

  /**
   * Handle checkbox toggle
   */
  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;

    // CASE 1: Multiple checkboxes → array
    if (Array.isArray(value)) {
      let updatedValue;

      if (checked) {
        // Prevent duplicates
        updatedValue = [...new Set([...value, field.value])];
      } else {
        updatedValue = value.filter((v) => v !== field.value);
      }

      handleChange({
        target: { name: field.name, value: updatedValue },
      });
      return;
    }

    // CASE 2: Single checkbox → boolean
    handleChange({
      target: { name: field.name, value: checked },
    });
  };

  // Generate a safe unique ID
  const inputId =
    field.id || `${field.name}-${field.value || "checkbox"}`;

  return (
    <div  className={field.fieldSize || "col-12 mt-3"}>
      <div className={`form-check ${field.inline ? "form-check-inline" : ""}`}>
        <input
          className={`form-check-input ${error ? "is-invalid" : ""}`}
          type="checkbox"
          id={inputId}
          name={field.name}
          value={field.value}
          checked={isChecked}
          disabled={disabled || field.disabled}
          onChange={handleCheckboxChange}
        />

        <label className="form-check-label" htmlFor={inputId}>
          {field.label}
        </label>

        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    </div>
  );
};

export default FormCheckbox;
